import { combineReducers } from 'redux';
import alert from './reducers/alert';
import auth from './reducers/auth';
import locations from './reducers/locations';
import directories from './reducers/directories';

export default combineReducers({
    alert, auth, locations, directories
});
